(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('{{ form_id }}');
    if (!form) return;

    // Encuentra el botón de submit (button o input)
    let btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!btn) return;

    // Asegura una clase común para estilizar
    if (btn.tagName.toLowerCase() === 'button') {
      btn.classList.add('contact-form__submit');
    }

    // Si es input, lo envolvemos para poder mostrar spinner con un elemento extra
    let wrap = null;
    if (btn.tagName.toLowerCase() === 'input') {
      wrap = document.createElement('span');
      wrap.className = 'contact-submit-wrap';
      btn.parentNode.insertBefore(wrap, btn);
      wrap.appendChild(btn);
    }

    const setLoading = (loading) => {
      if (btn.tagName.toLowerCase() === 'button') {
        btn.classList.toggle('is-loading', loading);
        btn.toggleAttribute('disabled', loading);
        btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      } else {
        // input type="submit"
        if (wrap) {
          wrap.classList.toggle('is-loading', loading);
          btn.toggleAttribute('disabled', loading);
          btn.setAttribute('aria-busy', loading ? 'true' : 'false');
          // crea/elimina spinner inline
          let spin = wrap.querySelector('.contact-inline-spinner');
          if (loading && !spin) {
            spin = document.createElement('span');
            spin.className = 'contact-inline-spinner';
            spin.setAttribute('aria-hidden', 'true');
            wrap.appendChild(spin);
          } else if (!loading && spin) {
            spin.remove();
          }
        }
      }
    };

    // Al enviar: activar spinner y bloquear doble submit
    form.addEventListener('submit', () => {
      // Evita re-activar si el navegador reintenta
      if (btn.disabled) return;
      setLoading(true);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
